<template>
    <div id="blog-search-container">
        <form autocomplete="off" @submit.prevent="submitSearch">
            <autocomplete
                    ref="blogSearch"
                    class="border-none form-input block text-16 tracking-widest placeholder-charcoal-lighter placeholder-opacity-75 text-charcoal-lighter"
                    id="keyword"
                    :minLength="1"
                    :prepopulateChosen="blogSearchQuery"
                    placeholder="What are you looking for?"
                    @onSubmit="submitSearch"
                    @onSelect="onSearchQuerySelect"
                    @onInput="onInputQuery"
                    :apiCall="blogsApiCall"
            />
        </form>
    </div>
</template>

<script>
    import CCRequestInputMixin from "../mixins/CCRequestInputMixin";

    import mainApp from "../app";

    export default {
        name: "BlogSearch",
        mixins: [CCRequestInputMixin],
        props: {
            blogsApiCall: {
                type: String,
                default: ''
            },

            urlArticles: {
                type: String,
                required: true
            },

            urlSearch: {
                type: String,
                required: true
            },
        },

        data() {
            return {
                blogSearchQuery: '',
            }
        },

        computed: {},

        methods: {
            /**
             * @param {string} val
             */
            onInputQuery( val ) {
                this.blogSearchQuery = val;
                this.$emit('search-text', val);
            },

            onSearchQuerySelect( val ) {
                this.blogSearchQuery = val;
                this.submitSearch()
            },

            submitSearch() {
                if (this.blogSearchQuery.toString().length > 0) {
                    window.location = this.addCCToRoute(`${this.urlSearch}/${this.blogSearchQuery}`);
                }else {
                    mainApp.toggleBlogNav();
                }
            },
        },
    }
</script>

<style lang="scss">

    #blog-search-container {
        .vue-simple-suggest {
            &.designed {
                .input-wrapper {
                    input {
                        border: none !important;
                        font-size: 0.875rem;
                        color: var(--charcoal-lighter);

                        &::placeholder {
                            font-size: 0.875rem;
                            color: var(--charcoal-lighter);
                            letter-spacing: normal;
                        }
                    }
                }
            }
        }
    }

</style>
